var PopupWidgetView = function (args) {
  this.$popup = $('#' + args.popupId);

  if (args.delegateFilter && args.delegateElement) {
    $(args.delegateElement).delegate(
      args.delegateFilter,
      'click',
      $.proxy(this.openPopup, this)
    );
  }

  this.centerOnOpen = args.centerOnOpen;
  this.appendToBody = args.appendToBody;
  this.appendedToBody = false;

  this.OPENING_EVENT = args.OPENING_EVENT;

  this.disableAfterOpen = args.DISABLE_AFTER_OPEN;
  this.trackerCookieKey = args.TRACKER_COOKIE_KEY;
};

PopupWidgetView.prototype.openPopup = function (e) {
  e = e || { currentTarget: null };

  var $elem = $(e.currentTarget);

  // Default action should not trigger for links
  // Following a link and opening a popup at the same doesn't make sense
  if ($elem.prop('tagName') === 'A' && !$elem.hasClass('leave-page-btn')) {
    e.preventDefault();
  }

  if (this.centerOnOpen) {
    // First, center the modal vertically
    var offset = (($(document).height() - this.$popup.height()) / 2) * 0.5;
    this.$popup.css('margin-top', offset);
  }

  // Second, fire off the "opening" event in case any other javascript needs to listen
  this.$popup.trigger(this.OPENING_EVENT, [
    e.currentTarget,
    $(e.currentTarget).data(),
  ]);

  // Third, show it and stop event propogation
  if (this.appendToBody && !this.appendedToBody) {
    this.$popup.appendTo('body');
    this.appendedToBody = true;
  }

  this.$popup.modal('show');

  if (this.disableAfterOpen) {
    document.cookie = this.trackerCookieKey + '=true;path=/';
  }
};

window.PopupWidgetView = PopupWidgetView; // Exposes for SiteJavascriptWidgetView
window.dispatchEvent(new Event('PopupWidgetView')); // Signals that definition is ready for use

export default PopupWidgetView;
